import type { Vacancy } from 'clients/AutoCompleteClient/types';
import { useCampaignSaveMutation } from 'hooks/campaigns/useCampaignSaveMutation';
import { useCallback, useMemo } from 'react';
import { useCampaignStore } from 'stores/campaign/campaign.store';
import { getVacancyName } from 'utils/vacancyEnrichedUtils';

export const useConnectToAts = () => {
  const campaignMutation = useCampaignSaveMutation();

  const campaign = useCampaignStore((s) => s.campaign);

  const onSelectAts = useCallback(
    async (ats: Vacancy | null): Promise<void> => {
      const atsId = ats?.value ?? null;

      if (!campaign) return;

      if (ats && ats.type !== 'ATS' && ats.type !== 'ATS_RAW') {
        throw new Error('Campaign only supports ATS and ATS_RAW vacancies');
      }

      await campaignMutation.mutateAsync({
        campaignId: campaign.id,
        data: { connected_ats: ats, is_ats_configured: !!atsId },
      });
    },
    [campaign],
  );

  const selectedAts = useMemo(() => {
    if (!campaign?.connected_ats) return null;

    return {
      ...campaign.connected_ats,
      name: getVacancyName(campaign.connected_ats),
      value: campaign.connected_ats.job_ats_id,
    };
  }, [campaign?.connected_ats]);

  return { selectedAts, onSelectAts };
};
